import { render, staticRenderFns } from "./TheNav.vue?vue&type=template&id=53185284&scoped=true"
import script from "./TheNav.vue?vue&type=script&lang=js"
export * from "./TheNav.vue?vue&type=script&lang=js"
import style0 from "./TheNav.vue?vue&type=style&index=0&id=53185284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53185284",
  null
  
)

export default component.exports